<template>
  <div class="legal-container">
    <h1>Política de Privacidade – Zinnes</h1>
    <p><strong>Data de Vigência: 17/05/2025</strong></p>

    <h2>1. Introdução</h2>
    <p>Bem-vindo à Zinnes, sua plataforma de leitura e publicação de quadrinhos, disponível em <a
        href="https://www.zinnes.com.br">https://www.zinnes.com.br</a>. Sua privacidade é uma prioridade para nós. Esta
      Política de
      Privacidade explica como coletamos, usamos, armazenamos, compartilhamos e protegemos suas informações quando você
      utiliza nossa plataforma. Ao acessar ou usar a Zinnes, você concorda com as práticas descritas nesta política.
      Caso não concorde, recomendamos que não utilize a plataforma.</p>

    <h2>2. Informações Coletadas</h2>
    <p>Nós coletamos diferentes tipos de informações para oferecer e melhorar nossos serviços:</p>
    <h3>2.1 Informações Pessoais</h3>
    <ul>
      <li><strong>Cadastro:</strong> Nome, e-mail, senha, nome de usuário, foto de perfil, biografia e outras
        informações fornecidas durante o registro.</li>
      <li><strong>Transações Financeiras:</strong> Dados de pagamento (como PayPal ou cartão de crédito) processados por
        parceiros terceirizados para compras ou doações na plataforma.</li>
    </ul>
    <h3>2.2 Informações de Navegação</h3>
    <ul>
      <li><strong>Cookies e Tecnologias de Rastreamento:</strong> Utilizamos cookies e tecnologias semelhantes (como web
        beacons) para melhorar sua experiência, personalizar conteúdo e analisar o tráfego. Isso inclui cookies de
        terceiros, como os usados pelo Google AdSense para exibir anúncios personalizados.</li>
      <li><strong>Dados de Navegação:</strong> Informações sobre seu dispositivo, navegador, endereço IP, geolocalização
        aproximada e páginas visitadas na plataforma.</li>
    </ul>
    <h3>2.3 Conteúdos Gerados pelo Usuário</h3>
    <ul>
      <li><strong>Quadrinhos e Materiais:</strong> Quadrinhos, ilustrações e outros conteúdos publicados por autores na
        plataforma.</li>
      <li><strong>Interações:</strong> Comentários, avaliações e outras interações realizadas com conteúdos da
        plataforma.</li>
    </ul>

    <h2>3. Uso das Informações</h2>
    <p>Usamos suas informações para:</p>
    <ul>
      <li>Fornecer acesso à plataforma e seus recursos, incluindo leitura e publicação de quadrinhos.</li>
      <li>Personalizar sua experiência com recomendações de leitura baseadas em suas preferências e interações.</li>
      <li>Processar transações financeiras, como compras, assinaturas ou doações.</li>
      <li>Enviar comunicações, como notificações sobre atualizações, novidades ou suporte, com seu consentimento.</li>
      <li>Analisar o uso da plataforma para melhorar funcionalidades, segurança e desempenho.</li>
      <li>Exibir anúncios personalizados por meio de parceiros como o Google AdSense, com base em seus dados de
        navegação e preferências.</li>
    </ul>

    <h2>4. Compartilhamento de Dados</h2>
    <p>A Zinnes <strong>não vende</strong> suas informações pessoais. No entanto, podemos compartilhar dados nas
      seguintes situações:</p>
    <ul>
      <li><strong>Prestadores de Serviços:</strong> Compartilhamos dados com empresas que nos ajudam a operar a
        plataforma, como provedores de hospedagem, serviços de pagamento (ex.: PayPal) e ferramentas de análise (ex.:
        Google Analytics).</li>
      <li><strong>Parceiros de Publicidade:</strong> Compartilhamos dados não identificáveis com redes de anúncios, como
        o Google AdSense, para exibir anúncios relevantes. Esses parceiros podem usar cookies para rastrear suas
        preferências e comportamento de navegação em outros sites. Os dados coletados podem ser compartilhados com o Google e seus parceiros para fins de exibição de anúncios personalizados, conforme as políticas de privacidade do Google.</li>
      <li><strong>Exigências Legais:</strong> Podemos divulgar informações para cumprir obrigações legais, responder a
        processos judiciais ou proteger os direitos, segurança e propriedade da Zinnes, seus usuários ou terceiros.</li>
      <li><strong>Com Consentimento:</strong> Compartilharemos dados com terceiros apenas com sua permissão expressa.
      </li>
    </ul>

    <h2>5. Cookies e Tecnologias de Rastreamento</h2>
    <p>Usamos cookies e tecnologias semelhantes para melhorar a navegação, personalizar conteúdo e exibir anúncios.
      Cookies são pequenos arquivos armazenados em seu dispositivo que ajudam a lembrar suas preferências. Parceiros
      como o Google AdSense utilizam cookies para oferecer anúncios personalizados com base em seus interesses.</p>
    <p><strong>Google como Fornecedor Terceirizado:</strong> O Google é um fornecedor terceirizado que utiliza cookies para exibir anúncios em nossa plataforma. O uso do cookie DART pelo Google permite exibir anúncios com base em visitas anteriores do usuário a sites da web. Você pode desativar o cookie DART visitando a <a href="https://policies.google.com/technologies/ads?hl=pt-BR" target="_blank" rel="noopener noreferrer">Política de Privacidade da Rede de Conteúdo e dos Anúncios do Google</a>.</p>
    <p><strong>Opt-out de Anúncios Personalizados:</strong> Os usuários podem optar por não receber anúncios personalizados acessando as <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">Configurações de Anúncios do Google</a> ou utilizando mecanismos de opt-out de terceiros, como <a href="https://www.aboutads.info" target="_blank" rel="noopener noreferrer">https://www.aboutads.info</a>.</p>
    <p>Você pode configurar seu navegador para recusar cookies ou ser notificado quando eles forem enviados. No entanto,
      algumas funcionalidades da plataforma podem não funcionar corretamente sem cookies. Para mais informações sobre os
      cookies do Google AdSense, visite <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">Políticas de Anúncios do
        Google</a>.</p>

    <h2>6. Segurança dos Dados</h2>
    <p>Adotamos medidas de segurança, como criptografia de senhas e práticas para prevenir acesso não autorizado. No
      entanto, nenhum sistema é completamente seguro, e não podemos garantir a proteção total contra violações de dados.
    </p>

    <h2>7. Direitos dos Usuários</h2>
    <p>Você tem os seguintes direitos em relação aos seus dados pessoais:</p>
    <ul>
      <li><strong>Acesso:</strong> Solicitar uma cópia dos dados pessoais armazenados.</li>
      <li><strong>Correção:</strong> Atualizar ou corrigir informações incorretas.</li>
      <li><strong>Exclusão:</strong> Solicitar a exclusão de sua conta e dados, salvo quando exigido por motivos legais
        ou transações em andamento.</li>
      <li><strong>Revogação de Consentimento:</strong> Retirar o consentimento para o uso de seus dados a qualquer
        momento.</li>
    </ul>
    <p>Para exercer esses direitos, entre em contato pelo e-mail <a
        href="mailto:druidazinnes@gmail.com">druidazinnes@gmail.com</a>.</p>

    <h2>8. Menores de Idade</h2>
    <p>A Zinnes não é destinada a menores de 13 anos. Não coletamos intencionalmente dados de menores de 13 anos sem o
      consentimento de um responsável legal. Se soubermos que coletamos tais dados, tomaremos medidas para excluí-los.
      A Zinnes não exibe anúncios personalizados para menores e adota medidas para cumprir a LGPD (Lei Geral de Proteção de Dados) e a COPPA (Children's Online Privacy Protection Act).
    </p>

    <h2>9. Alterações na Política de Privacidade</h2>
    <p>Podemos atualizar esta política periodicamente para refletir mudanças na plataforma ou em leis aplicáveis.
      Alterações significativas serão notificadas por meio de um aviso na plataforma. A versão mais recente estará
      sempre disponível em <a
        href="https://www.zinnes.com.br/politica-de-privacidade">https://www.zinnes.com.br/politica-de-privacidade</a>.
    </p>

    <h2>10. Sobre Nós</h2>
    <p>A Zinnes é uma plataforma apaixonada por quadrinhos, criada para conectar autores e leitores em um ambiente
      criativo e inovador. Nossa equipe é composta por:</p>
    <ul>
      <li><strong>Andy Ichigo:</strong> Artista de mangá e quadrinhos de São Paulo, SP, reconhecido pela one-shot “My
        World”, vencedora do 5º Concurso de Mangás do Estúdio Armon. Trabalhou com editoras underground e independentes,
        como Aquele Velho Mar, Syncro e Amor Sismico.</li>
      <li><strong>Felipe Lee:</strong> Diretor e sócio fundador da Zinnes, com quase 10 anos de experiência em
        gerenciamento de projetos, storyboard e edição de filmes. Apaixonado por quadrinhos, também é autor e animador
        nas horas vagas.</li>
      <li><strong>Fernando:</strong> Quadrinista há 15 anos, criou obras como TDF, A Experiência, Syncro I e Potric.
        Apaixonado por criar mundos e personagens que emocionam e inspiram os leitores.</li>
      <li><strong>Guilherme:</strong> Escritor, roteirista e diretor da Zinnes, cuida das relações públicas e participa
        da construção de projetos. Autor de Karma, Agatha e o Reino Sombrio, Rei do Norte e Tribos.</li>
    </ul>

    <h2>11. Contato</h2>
    <p>Para dúvidas ou preocupações sobre esta Política de Privacidade, entre em contato:</p>
    <p><strong>E-mail:</strong> <a href="mailto:druidazinnes@gmail.com">druidazinnes@gmail.com</a><br>
      <strong>CNPJ:</strong> 52.230.302/0001-50
    </p>

    <div class="footer">
      <p>Zinnes – Sua plataforma de quadrinhos!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
}
</script>

<style scoped>
body {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  margin: 0;
  padding: 0;
  background-color: #f9f9f9;
}

.legal-container {
  max-width: 800px;
  margin: 2rem auto;
  padding: 1rem 2rem;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

h1 {
  color: #631b8d;
  text-align: center;
  margin-bottom: 1.5rem;
}

h2 {
  color: #631b8d;
  margin-top: 2rem;
}

p,
li {
  margin-bottom: 1rem;
}

ul {
  list-style-type: disc;
  margin-left: 2rem;
}

a {
  color: #631b8d;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.about-us {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #ddd;
}

.footer {
  text-align: center;
  margin-top: 2rem;
  font-size: 0.9rem;
  color: #666;
}

@media (max-width: 600px) {
  .legal-container {
    padding: 1rem;
  }
}
</style>
